/**
 * Packet Log Component - Shows history of sent packets
 */

import React from 'react';
import { useSimulatorStore } from '../../stores/simulatorStore';
import { format } from 'date-fns';
import { cn } from '../../lib/utils';

export const PacketLog: React.FC = () => {
  const { packetLog, clearLog } = useSimulatorStore();

  if (packetLog.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 mt-6">
        <h3 className="text-xl font-bold mb-4">Packet Log</h3>
        <p className="text-center text-gray-500 py-8">
          No packets sent yet. Use Quick Actions or Custom Packet Builder to send test data.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mt-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-bold">Packet Log</h3>
        <button
          onClick={clearLog}
          className="px-3 py-1 text-sm bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
        >
          Clear Log
        </button>
      </div>

      <div className="max-h-96 overflow-y-auto space-y-2 bg-gray-50 p-4 rounded-lg font-mono text-sm">
        {packetLog.map((log) => (
          <div
            key={log.id}
            className={cn(
              'p-3 rounded border-l-4',
              log.success
                ? 'bg-green-50 border-green-500 text-green-900'
                : 'bg-red-50 border-red-500 text-red-900'
            )}
          >
            <div className="flex items-start justify-between">
              <span className="font-semibold">
                {log.success ? '✅' : '❌'} {log.description}
              </span>
              <span className="text-xs text-gray-600 ml-2">
                {format(new Date(log.timestamp), 'HH:mm:ss')}
              </span>
            </div>
            <div className="text-xs text-gray-600 mt-1">{log.timestamp}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

